import AuthLayout from "@/components/layouts/auth-layout";
import ResetPasswordForm from "@/components/organisms/forms/auth/reset-password-form";

type ResetPasswordProps = {
  resolution: Resolution;
};

const ResetPassword = ({ resolution }: ResetPasswordProps) => {
  const [route] = resolution.slugs;
  const { locale } = resolution;

  return (
    <AuthLayout route={route} locale={locale}>
      <ResetPasswordForm locale={locale} />
    </AuthLayout>
  );
};

export default ResetPassword;
